import React, { useState, useEffect, Fragment } from 'react';
import TabSelector from 'components/Shared/Filters/TabSelector';
import Table, { RowType } from '../../Shared/CustomTable';
import EditableField from 'components/Shared/EditableField';
import { useDataEventsState, useGamesDispatch, usePlaysState } from 'store/hooks';
import Loader from 'components/Shared/Loader';
import { useFlagsDispatch, useFlagsState } from 'store/hooks/flags';
import { message } from 'antd';
import { useRouter } from 'helpers/customHooks';
import { PerformanceRoutes } from '../TabPerformance/types';

interface PlaysType {
    playId: string;
    nflId: string;
}
interface GameManagerType {
  plays: PlaysType[];
}


const TabGameManage = () => {
    const { meta } = useDataEventsState();
    const { playsIgnored } = usePlaysState();
    const { playsSavedFlag, reprocessFlag } = useFlagsState();
    const { playsIgnoreSavedFlag, gameReprocessFlag } = useFlagsDispatch();
    const {
      specificScope: scope,
    } = useRouter<PerformanceRoutes>();
    const hideMessages = () => {
      if(playsSavedFlag) playsIgnoreSavedFlag(false);
      if(reprocessFlag) gameReprocessFlag(false); 
    };
    const  {getIgnorePlays, saveIgnorePlays, reprocessGame} = useGamesDispatch();
    const [show, setShow] = useState(-1);
    const [editable, setEditable] = useState(false);
    const initialState: GameManagerType= {
        plays: [],
    };
    const gameId = meta.gameId;
    const [currentPlays, setCurrentPlays] =  useState(initialState);
    const [currentPlaysCopy, setCurrentPlaysCopy] =  useState(initialState);
    const [invalidPlayId, setinvalidPlayId] =  useState(false);
    const [invalidNflId, setinvalidNflId] =  useState(false);
    const now = new Date();
    const currentTimestamp = now.getTime();
    const tableScope = scope.split(':');

    useEffect(() => {
      getIgnorePlays(meta.gameId);

    }, [meta.gameId]);

    useEffect(() => {
     if(playsIgnored && playsIgnored && playsIgnored[gameId]){
      const ignorePlaysConverted: PlaysType[] = [];
      playsIgnored[gameId].forEach((play:any) => {
        const playId = Object.keys(play)[0];
        const nflId = play[playId];
        
        ignorePlaysConverted.push({ playId, nflId });
      });
      setCurrentPlays({plays: ignorePlaysConverted});
      setCurrentPlaysCopy({plays: ignorePlaysConverted}); 
    }
    
    }, [playsIgnored]);

    useEffect(() => {
      if(currentPlaysCopy && currentPlaysCopy.plays){
        currentPlaysCopy.plays.some((play:PlaysType)=>{
          if (play.nflId === '' || play.nflId.length <= 4 ) {
            setinvalidNflId(true);
            return true;
          }else{
            setinvalidNflId(false);
          }
          if(play.playId === '' || play.playId.length <= 1 ){
            setinvalidPlayId(true);
            return true;
          }else{
            setinvalidPlayId(false);
          }
        });
        if(currentPlaysCopy.plays.length === 0){
          setinvalidNflId(false);
          setinvalidPlayId(false);
        }
      } 
     }, [currentPlaysCopy]);


  const handleEditingChange = () => {
    if(currentTimestamp >= meta.startTime){
    if(editable){
      setCurrentPlaysCopy(currentPlays);
      
    }
      setEditable(!editable);

  }

  };
  const handleAddPlay = () => {
    const newStatus = JSON.parse(JSON.stringify(currentPlaysCopy));
    if (!newStatus.plays) {
      newStatus.plays = [];
    }
    newStatus.plays.push({
      playId:'',
      nflId: ''
  
    });
    setCurrentPlaysCopy(newStatus);
  };
  const handlePlayIdChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const value = event.target.value;
    if (!/^\d*$/.test(value)) return;
    const newPlays = JSON.parse(JSON.stringify(currentPlaysCopy));
    newPlays.plays[index].playId = value;
    setCurrentPlaysCopy(newPlays);

    setinvalidPlayId(value.length <= 1);
};
  const handleNflIdChange = (event:React.ChangeEvent<HTMLInputElement>, index:number) => {
     const value = event.target.value;
     if (!/^\d*$/.test(value)) return;
     const newPlays = JSON.parse(JSON.stringify(currentPlaysCopy));
     newPlays.plays[index].nflId = value;
     setCurrentPlaysCopy(newPlays);

     setinvalidNflId(value.length <= 4);
  };

  const handleDeletePlay = (index:number) => {
    const newPlays = JSON.parse(JSON.stringify(currentPlaysCopy));
    newPlays.plays.splice(index, 1);
    setCurrentPlaysCopy(newPlays);
  };

  const handleSave = () =>{
    const transformedArray = currentPlaysCopy.plays.map(item => ({
      [item.playId]: item.nflId
    }));
    saveIgnorePlays(gameId, transformedArray);
    setEditable(false);
  };

  const handleReprocess = async() =>{
    reprocessGame(gameId);
  };
  useEffect(() => {
   
    if (reprocessFlag) {
      // show message and then clear flags
      if(reprocessFlag === '0'){
        message.success({
          content: 'Game Reprocessing. Check slack for status',
          className: 'message-pro',
          style: {
            marginTop: '60vh'
          }
        }, 15);
      }
      if(reprocessFlag === '100'){
        message.success({
          content: 'Game processing queue, please wait till current games finish processing',
          className: 'message-pro-error',
          style: {
            marginTop: '60vh'
          }
        }, 15);
      }
      if(reprocessFlag === '-1'){
        message.success({
          content: 'Error',
          className: 'message-pro-error',
          style: {
            marginTop: '60vh'
          }
        }, 15);
      }
      
      hideMessages();
    }

    if (playsSavedFlag) {
      // show message and then clear flags
      message.success({
        content: 'Changes Were Successfully Saved',
        className: 'message-pro',
        style: {
          marginTop: '60vh'
        }
      }, 10);
      hideMessages();
    }
  
   }, [reprocessFlag, playsSavedFlag]);

  const headers = [
    { content: ' ', style: { width: '473px' }, class: 't-ll' },
    { content: 'PLAY ID', style: { width: '120px' }, class: 't-ll' },
    { content: 'NFL ID', style: { width: '120px' }, class: 't-ll' },
    { content: ' ', style: { width: '90px' },  },
    { content: ' ', style: { width: '473px' },  },
  ];
  let rows:RowType[] = [];

  if (currentPlaysCopy.plays) {
    //@ts-ignore
    rows = currentPlaysCopy.plays.map((play, index) => {
   
      return({
        columns:[
          {class: 't-ll'},
          {
            content: play.playId ? play.playId : '',
            class: 't-ll tt-qq',
            style: { padding: '19px 20px'},
            print: content => (
              <EditableField
                itemId={index as number} editable={editable} text={content}
                handleChange={handlePlayIdChange}
                playId={true}
              />
            )
          },
          {
            content: play.nflId ? play.nflId : '',
            class: 't-ll tt-qq',
            style: { padding: '19px 20px'},
            print: content => (
              <>
              <EditableField
                itemId={index as number} editable={editable} text={content}
                handleChange={handleNflIdChange}
                nflId={true}
              />
              </>
            )
          },
          {
            style: {
              color: '#4F9300',
              fontWeight: 'bold',
              fontSize: '13px',
              padding: '19px 20px'
            },
            print: () => (
              <>
              { editable ? 
              <button className="trash-00" onClick={()=>handleDeletePlay (index)}>
              <img src="/assets/trash.svg" alt="" height="20px" />
            </button> :
            ''
              }
              
            </> 
            )
          },
          {}
          
        ],
        id: index
      });
    });
  }
  
return(
    <>
    <div className="new-manage">
        <Fragment>
            <TabSelector show={show === 1} open={() => setShow(1)} close={() => setShow(-1)} />
            <div className="manage-btn">
                <div className={'switch-00'}>
                    <label className="label-009" onClick={()=>{handleEditingChange();}}>{'Editing ' + (editable ? 'Unlocked' : 'Locked')}</label>
                    <input
                        type="checkbox" id="editing-practice-manager" name="set-name" className="switch-input"
                        checked={ editable}
                        onChange={() => handleEditingChange()}
                    />
                    <label htmlFor="editing-practice-manager" id="editing-practice-manager-label" className="switch-label" />
                </div>
                <button
                    onClick={handleSave}
                    className={'btn-green'} 
                    style={editable ? (invalidNflId || invalidPlayId)? {opacity: 0.5, cursor: 'default', pointerEvents: 'none'} : {} : {opacity: 0.5, cursor: 'default', pointerEvents: 'none'}}>
                        Save
                </button>
                <button
                    onClick={handleReprocess}
                    className={'btn-green'} 
                    style={!editable && (currentTimestamp >= meta.startTime) ? {width: '120px'} : {opacity: 0.5, cursor: 'default', pointerEvents: 'none', width: '120px'}}>
                        Reprocess Game
                </button>
            </div>
        </Fragment>
    </div>
    <div className="manage-head">
          Removed Plays
    </div>
    <div className="manage-body monitor" style={{ overflow: 'hidden' }}>
        <div
            style={{ height:  '100%' }}
            className="periods-table-box"
        >
          <Loader forceLoader={!playsIgnored[gameId]} forceMessage={currentTimestamp<=meta.startTime? 'Game Manager will be available upon completion of game processing.' : undefined}>
            <div style={{ height: 'calc(100% - 48px' }}>
                {/* @ts-ignore */}
                <Table<HeadsType, RowType>
                  classTable="condensed-view"
                  forceScope={tableScope[0]+tableScope[1]}
                  headers={headers}
                  rows={rows}
                />
          </div>
          </Loader>
      <div
        onClick={handleAddPlay}
       style={{
        background: '#F5F5F5',
        zIndex: 7,
        display: editable ? undefined : 'none',
        height: '48px',
        width: '100%',
        fontSize: '25px',
        textAlign: 'center',
        fontWeight: 500,
        color: '#007ABA',
        cursor: 'pointer',
        // boxShadow: '0px 0px 3px rgba(0,0,0,0.3)',
        fontFamily: 'Roboto',
        position: 'relative',
        bottom: '0'
      }}
      >
        <label
          className="ll-m-01"
          style={{
            fontSize: '36px',
            lineHeight: '20px',
            cursor: 'pointer',
            position: 'absolute',
            top: '12px',
            left: 'calc(45%)'
          }}
        >+</label>
        <label
          className="ll-m-02"
          style={{
            fontSize: '14px',
            lineHeight: '20px',
            cursor: 'pointer',
            position: 'absolute',
            top: '14px',
            left: 'calc(45% + 26px)'
          }}
        >Add Play</label>
        </div>
        </div>
      
   </div>
    
    
    </>
);
};

export default TabGameManage;
